import {ExamProviderAccredited} from 'domain/usecases/private/booking-flow/exams/get-exams-provider-location-accredited';
import {getAddressforMaps, parsePhoneNumbers} from 'presentation/utils';
import {ExamUnits} from '../types';

export const parseExamAccreditedUnits = (units: ExamProviderAccredited[]): ExamUnits[] =>
	units?.map(unit => {
		const address = getAddressforMaps({
			address: unit?.logradouro,
			district: unit?.nmBairro,
			city: unit?.nmCidade,
			state: unit?.cdUf,
			zipCode: unit?.cep,
		});

		return {
			code: unit?.codigo?.toString(),
			name: unit?.nmFantasia || unit?.nmPrestador || (unit?.nmLocal ?? ''),
			stateCode: unit?.cdUf,
			city: unit?.nmCidade,
			addressNumber: '',
			addressName: unit?.logradouro,
			addressComplement: '',
			district: unit?.nmBairro,
			cep: unit?.cep,
			latitude: unit?.latitude || '',
			longitude: unit?.longitude || '',
			distance: unit?.distancia,
			nmBairroOrigem: unit?.nmBairro,
			formattedAddress: address.formattedAddress,
			phoneNumbers: parsePhoneNumbers(unit?.nuTelefone),
		};
	});
